export const ErrorsEnum = {
  DATA_ONLY: 'DATA_ONLY',
  IN_TRANSFER: 'IN_TRANSFER',
  SUSPENDED: 'SUSPENDED',
  SUSPENDED_SUBSCRIBER_LOST_OR_STOLEN: 'SUSPENDED_LOST_OR_STOLEN',
  FINANCIAL_PAYMENT_UPDATE_ERROR: 'FINANCIAL_PAYMENT_UPDATE_ERROR',
  FINANCIAL_DEBT_ERROR: 'FINANCIAL_DEBT_ERROR',
  DEBT_PAYMENT_METHOD: 'DEBT_PAYMENT_METHOD',
  IS_BUSINESS: 'IS_BUSINESS',
  NOT_SUBSCRIBED: 'NOT_SUBSCRIBED',
  SUBMIT_PACKAGE_FAILED: 'SUBMIT_PACKAGE_FAILED',
  GENERAL_ERROR: 'GENERAL_ERROR',
};

